import { DateTime } from "luxon";

/**
 * Formats a relative time string with abbreviated units for compact display.
 * e.g., "Last synced 3 min ago", "Last synced 2 hr ago"
 */
export function formatCalendarSyncTime(value: string | null): string | null {
  if (!value) return null;

  let dateTime: DateTime | null = null;

  try {
    dateTime = DateTime.fromISO(value, { setZone: true });
    if (!dateTime.isValid) {
      const jsDate = new Date(value);
      dateTime = Number.isNaN(jsDate.getTime()) ? null : DateTime.fromJSDate(jsDate);
    }
  } catch {
    return null;
  }

  if (!dateTime || !dateTime.isValid) {
    return null;
  }

  const now = DateTime.now();
  const diffMinutes = Math.floor(now.diff(dateTime, "minutes").minutes);
  const diffHours = Math.floor(now.diff(dateTime, "hours").hours);

  if (diffMinutes < 1) {
    return "Last synced just now";
  }

  if (diffMinutes < 60) {
    return `Last synced ${diffMinutes} min ago`;
  }

  if (diffHours < 24) {
    return `Last synced ${diffHours} hr ago`;
  }

  // For longer periods, use Luxon's relative formatting
  const relativeTime = dateTime.toRelative({
    unit: ["years", "months", "weeks", "days"],
  });

  return relativeTime ? `Last synced ${relativeTime}` : null;
}
